export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10 0 5.28-4.092 9.6-9.277 9.97l.057-12.703 2.938 2.937a.75.75 0 1 0 1.06-1.06l-4.22-4.221a.75.75 0 0 0-1.06 0l-4.254 4.254a.75.75 0 1 0 1.06 1.06l2.976-2.975-.057 12.705C6.063 21.57 2 17.26 2 12 2 6.477 6.477 2 12 2Z"/>
</svg>
`;
